import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    color: "white",
  },
}))

export default styles
